import { render, staticRenderFns } from "./testEditPackage.vue?vue&type=template&id=5480276d&"
import script from "./testEditPackage.vue?vue&type=script&lang=js&"
export * from "./testEditPackage.vue?vue&type=script&lang=js&"
import style0 from "./testEditPackage.vue?vue&type=style&index=0&id=5480276d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports